import cn from 'classnames';
import styles from './Backdrop.module.scss';

export default function Backdrop({ isOpen, onClick }) {
  return (
    <div className={cn(styles.backdrop, isOpen && styles.backdrop_visible)} onClick={onClick} />
  );
}
